<div class="row text-center">
  <div class="justify-content-center col">
    <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
  </div>
</div>